import Vue from 'vue'
import App from '@/layout/app/App.vue'
import Const from '@/helpers/const'
import router from './router'
import store from './store'
import Toasted from 'vue-toasted'
import './plugins'
import vuetify from './plugins/vuetify'
import { sync } from 'vuex-router-sync'
import * as firebase from 'firebase/app'
import 'firebase/analytics'
import 'firebase/firestore/memory'
import 'firebase/auth'
import Amplify from '@aws-amplify/core'
import awsconfig from './aws-exports'
import VueGtag from 'vue-gtag'

// Components
import './components'

sync(store, router)

let app = ''

firebase.initializeApp(Const.FIREBASE_CONFIG())
firebase.analytics()

Amplify.configure(awsconfig)

Vue.prototype.$db = firebase.firestore()
Vue.prototype.$auth = firebase.auth()
Vue.prototype.$date = firebase.firestore.FieldValue.serverTimestamp()

Vue.use(Toasted)
Vue.use(vuetify)

Vue.use(VueGtag, {
  config: { id: Const.FIREBASE_CONFIG().measurementId }
})

// TODO(vignatti): we want to use Vuex instead
Vue.prototype.$bus = new Vue({})

firebase.auth().onAuthStateChanged(() => {
  app = new Vue({
    theme: {
      dark: true,
    },
    router,
    store,
    vuetify,
    render: h => h(App),
  })
  app.$mount('#app')
})
